export default __webpack_public_path__ + "static/media/Bracers of Dark Terror.ae6d39c4.jpg";